import { Form } from "antd";
import moment from "moment";
import { Button } from "react-bootstrap";
import { getEnv } from "../../../../AppConfigs";
import { FontFa } from "../../../../components";
import ViagsModalForm from "../../../../components/viags-modal-form/viags-modal-form";
import { DateFormat } from "../../../../constants";
import PERMISSIONS from "../../../../constants/permissions";
import { useUser } from "../../../../hook";
import { useSearchParams } from "../../../../hook/use-search-params";
import { Employee } from "../../../../services/department-viags/employee-viags.service";
import { MailService } from "../../../../services/mail/mail.service";
import { useCreateNotify } from "../../../notify/hooks/use-create-notify";
import { useUpdateDocumentPublicInfo } from "../../hooks";
import { MailDocumentType, mailPublishMultipleFile, PublishMultipleFileMailProps } from "../../utils/mailTemplate";
import { PublishMultipleFileFormItem } from "./publish-multiple-file-form-item";

type ViewEmployeeType = Employee & { isView: boolean; isEdit: boolean; depList: any[] };

type FormItemType = {
  documentData: any[];
  employeeData: ViewEmployeeType[];
};

const baseUrl = getEnv("REACT_APP_DOMAIN_URL");

export const PublishMultiplePublishFileModal = ({
  documentData,
  disabled,
  getDocumentData,
  isPublish = false,
}: any) => {
  const [form] = Form.useForm();
  const { searchParams, replaceSearchParams } = useSearchParams();
  const { mutate } = useUpdateDocumentPublicInfo();
  const { name, email } = useUser();
  const { addNotify } = useCreateNotify();

  const handleClose = () => {
    form.resetFields();
    searchParams.delete("deptCode");
    replaceSearchParams(searchParams);
  };

  const handleFinish = (values: FormItemType) => {
    const { documentData, employeeData } = values;
    const filteredEmployeeData = employeeData.filter((e) => e.isView || e.isEdit);
    const mappedEmployeeData = filteredEmployeeData.map((e) => ({
      Claims: `i:0#.f|membership|${e.employeeEmail}`,
      Id: e.employeeCode,
      displayName: e.employeeName,
      email: e.employeeEmail,
      jobTitle: "",
      department: e.departmentName,
      departmentCode: e.departmentCode,
      departmentId: e.departmentId,
      pDeptCode: e.depList?.at(1)?.name_VN,
      isView: e.isView,
      isEdit: e.isEdit,
    }));

    const listDocument: MailDocumentType[] = [];

    documentData.forEach((e) => {
      const fileAssignedTo = !e.fileAssignedTo ? [] : JSON.parse(e.fileAssignedTo);
      const newFileAssigned = [...fileAssignedTo, ...mappedEmployeeData];
      const distinctEmails = [...new Map(newFileAssigned.map((item) => [item.email, item])).values()];
      const updateFields = {
        fileAssignedTo: JSON.stringify(distinctEmails),
      };
      mutate({ id: e.id + "", body: updateFields });

      const fields: MailDocumentType = {
        Title: e.Title ?? "",
        docCode: e.docCode ?? "",

        docPublishViewVersion: e.docPublishViewVersion ?? "",
        docEditionVersion: e.docEditionVersion ?? "",
        startDate: moment().format(DateFormat.DD_MM_YYYY),
        url: `${baseUrl}/document/detail/${e?.docWorkingId}?fileId=${e?.workingFileId}&action=info&status=publish&index=2`,
      };

      listDocument.push(fields);
    });

    const listSendEmail = employeeData.map((e) => e.employeeEmail);
    sendMail(listDocument, listSendEmail);
    return true;
  };

  const sendMail = (listDocument: MailDocumentType[], listEmail: string[]) => {
    const sendMailParams: PublishMultipleFileMailProps = {
      listDocument: listDocument,
      message: "",
      publishDepartment: "",
      userDisplayName: name ?? "",
      userEmail: email ?? "",
    };
    const subject = "TRIỂN KHAI TÀI LIỆU MỚI";
    const content = mailPublishMultipleFile(sendMailParams);
    const fieldsNotify = {
      Title: subject,
      N_x1ed9_idung: content,
      NotifyTo: listEmail.join(";"),
    };
    addNotify(fieldsNotify);
    MailService.sendMailByBotit({ content, subject, toMail: listEmail.join(";") });
    // const mail = MailService.buildMailMesssageForPeople(subject, content, "html", listEmail);
    // MailService.sendMail(mail);
  };

  return (
    <ViagsModalForm
      triggerPermission={PERMISSIONS.DEPLOY_DOCUMENT}
      trigger={
        <Button disabled={disabled} title={"Phân phối nhiều tài liệu"} className="mb-2 mr-2" variant="primary">
          <FontFa name="faFileExport" size={"lg"} /> Phân phối nhiều tài liệu
        </Button>
      }
      modalProps={{
        title: "Phân phối nhiều tài liệu",
        width: "90vw",
        destroyOnClose: true,
        afterClose: handleClose,
      }}
      form={form}
      labelCol={{ span: 6 }}
      size="large"
      layout="horizontal"
      onFinish={handleFinish}
    >
      <PublishMultipleFileFormItem documentData={documentData} isPublish={isPublish} />
    </ViagsModalForm>
  );
};
